import { Component, Input, inject } from '@angular/core';
import { LegalizationStatusEnum } from 'src/app/models/enums/legalization-status-enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-legalization-status-info',
  templateUrl: './legalization-status-info.component.html',
  styleUrl: './legalization-status-info.component.scss',
  standalone: false
})
export class LegalizationStatusInfoComponent {
  private translateService = inject(TranslateService);

  @Input() element: any;
  @Input() showStatusText: boolean = false;
  @Input() showTooltip: boolean = true;
  @Input() size: 'small' | 'normal' | 'large' = 'normal';
  @Input() showLabel: boolean = false;
  @Input() customLabel: string = null;

  constructor() { }

  get iconData() {
    if (this.element?.IsLegalizationDocumentRequiresCorrection) {
      return {
        icon: 'info',
        class: 'info-icon',
        fontSet: 'material-icons-outlined',
      };
    }

    if (this.hasStatus(LegalizationStatusEnum.Approved, this.element?.LegalizationStatusId)) {
      return {
        icon: 'check_circle_outline',
        class: 'success-icon',
      };
    }

    return {
      icon: 'cancel',
      class: 'error-icon',
      fontSet: 'material-icons-outlined',
    };
  }

  get labelText(): string {
    return this.customLabel || `${this.translateService.instant('Legalization.LegalizationStatus')} :`;
  }

  get tooltipText(): string {
    if (!this.element?.LegalizationStatusName) {
      return `${this.translateService.instant('Legalization.LegalizationStatus')} : ${this.translateService.instant('Legalization.Status.ReadyForLegalization')}`;
    }

    if (this.element.IsLegalizationDocumentRequiresCorrection) {
      return `${this.translateService.instant('Legalization.RequiresCorrectionInformation')}
        ${this.translateService.instant('Legalization.LegalizationStatus')} : ${this.element.LegalizationStatusName}`;
    }
    return `${this.translateService.instant('Legalization.LegalizationStatus')} : ${this.element.LegalizationStatusName}`;
  }

  private hasStatus(expectedLegalizationStatusId: number, currentLegalizationStatusId: number): boolean {
    return expectedLegalizationStatusId === currentLegalizationStatusId;
  }
}
